import { render, staticRenderFns } from "./wa-header.vue?vue&type=template&id=b45f8b22&scoped=true&"
import script from "./wa-header.vue?vue&type=script&lang=js&"
export * from "./wa-header.vue?vue&type=script&lang=js&"
import style0 from "./wa-header.vue?vue&type=style&index=0&id=b45f8b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45f8b22",
  null
  
)

export default component.exports